import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { track } from '@mwe/utils';

@Component({
  selector: 'mwe-card-clickable',
  templateUrl: './card-clickable.component.html',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardClickableComponent {
  cardTitle = input.required<string>();
  cardIcon = input.required<string>();
  ariaLabel = input<string>('');
  isLoading = input<boolean>(false);
  testId = input<string>('');
  readonly cardClicked = output();

  private readonly translateService = inject(TranslateService);

  onCardClick() {
    if (this.isLoading()) {
      return;
    }
    track('mwe_card_clickable', {
      card_action_type: 'click',
      card_label: this.translateService.instant(this.cardTitle()),
    });
    this.cardClicked.emit();
  }
}
